#import '../fragment/aggregatedTransaction.graphql'

query aggregatedTransactions($endDate: Date, $startDate: Date) {
  aggregatedTransactions(endDate: $endDate, startDate: $startDate) {
    ...aggregatedTransactionFragment
  }
}
